import React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const StyledTitleInput = styled.input`
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.text};
  font-size: ${theme.typography.xl};
  padding: ${theme.spacing.sm};
  width: 100%;
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    border-width: 2px;
  }
`

const ParseIndicator = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: ${(props) => (props.$isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  
  &::after {
    content: '';
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`

interface TitleInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  showParseIndicator?: boolean
}

export const TitleInput = React.forwardRef<HTMLInputElement, TitleInputProps>(
  ({ showParseIndicator = false, ...props }, ref) => {
    return (
      <Container>
        <StyledTitleInput ref={ref} {...props} />
        <ParseIndicator $isVisible={showParseIndicator} />
      </Container>
    )
  }
)
